import axios from "axios";
import {LOCAL_API_URL, SUBSCRIPTION_KEY} from "../config/config";

class QueryService {
  retryCount = 5;
  private _apiEndpoint = process.env.REACT_APP_LOCAL_API_URL;

  constructor(API: string = process.env.REACT_APP_LOCAL_API_URL||'') {
    this._apiEndpoint = API;
  }

  getConfig = () => {
    return {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // Authorization:
        //   "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IkwxS2ZLRklfam5YYndXYzIyeFp4dzFzVUhIMCIsImtpZCI6IkwxS2ZLRklfam5YYndXYzIyeFp4dzFzVUhIMCJ9.eyJhdWQiOiIzMmRkMzQzNy03ZTY2LTQzNjUtODI1NS0yMmQxMTA2MTU2ZDgiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC83ZWI1NTMxNC1iMGJhLTQ3YWItOTZjOS00OWNkOTQ4YTcyZWUvIiwiaWF0IjoxNzE2MzAyMTM1LCJuYmYiOjE3MTYzMDIxMzUsImV4cCI6MTcxNjMwNjAzNSwiYWlvIjoiQWFRQVcvOFdBQUFBd0Y1S3Y4WHVnbEFDM3hTSHZYbFhmdkw3eG1uaVlyM1NlSEhValo3emtlUzVWQ21nWjYzSS9tV0V4cWt5c1N0TjRSRzVuU0FmTmJvL1Bsb3l0VXJ5Ujk2S2hOa3RVOUgyMGkvem41Q0xmbDRrMGE2MXJ2NU5NZnFwWU5hVW9pcTlQYlhNbGE1U1c5TnpFZmRqY0N5RHVVY1hONnQ1RTcrRXBCTFE2ZGxhUXRVQmR0RVVWbXpUNHVWenNWRmVzQmR2S2pZTlk4RzRSYUp0SGZRR0NYakcrZz09IiwiYW1yIjpbInB3ZCIsInJzYSJdLCJlbWFpbCI6ImRoYWFnZ2Fyd2FsQGRlbG9pdHRlLmNvbSIsImlkcCI6Imh0dHBzOi8vc3RzLndpbmRvd3MubmV0LzM2ZGE0NWYxLWRkMmMtNGQxZi1hZjEzLTVhYmU0NmI5OTkyMS8iLCJpcGFkZHIiOiIxNjcuMjE5LjAuMTQwIiwibmFtZSI6IkFnZ2Fyd2FsLCBEaGFybWFuc2giLCJub25jZSI6ImFiNDQ1ZmQ1LWUxMTktNDAxNC04MjU4LWMxZTM5NzA2NzU3MSIsIm9pZCI6IjlmNmQ5YzBjLTg5NTMtNDczNy04YWRiLTg2MTNhZGQ4ZmZkNCIsInJoIjoiMC5BU1lBRkZPMWZycXdxMGVXeVVuTmxJcHk3amMwM1RKbWZtVkRnbFVpMFJCaFZ0Z1ZBRW8uIiwic3ViIjoiZGliSnMzcWhSTi1pRmNWLXJQZ1dZSWdZUHhwRDN1RG1kTnJCcEttZzNtYyIsInRpZCI6IjdlYjU1MzE0LWIwYmEtNDdhYi05NmM5LTQ5Y2Q5NDhhNzJlZSIsInVuaXF1ZV9uYW1lIjoiZGhhYWdnYXJ3YWxAZGVsb2l0dGUuY29tIiwidXRpIjoianJ0ZVpkTWM5a1NhNzZ1b1l5aGdBQSIsInZlciI6IjEuMCJ9.ZzPD9hyej-KFYVdDJeXeTYAilMQ9KuFhQwYqQJfeohl31UJQwWQriiz3Su5afshH8vDQsvs7S53vlK-dX_JljPHRhM06rUYfKtWpv5T04jHLV9AH6jK2x4CWP0rF5aBPeokjLFk9WFC8RGyTyoEsVoP0ntyKoclzX3kEEcgCr5DFOpE7OBAP8V-lEb34v8i3_mNiHfnwZlo7A0yddiTUGv0OD8rOBqnjZGhndaH5SCcvZJZxMZxLGgRj5088KYLMVd3JZFCmLGeqAD2mnURgMfQ2AW5Pnj4ZYcN93KSob5p2QJU-ZJE8e-8-eob9zNf9QUaSw29BR0h6bJLZsQfiuA",
        "Authorization" : `Bearer ${localStorage.getItem("accessToken")}`,
        "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSCRIPTION_KEY,
      },
      data: {},
    };
  };

  /**
   * Base query to make calls to the backend
   * @param {string} relativeURL - the extended URL to be called
   * @param {string} method - the http method to be executed - default to GET
   * @param {any} payload - the payload in cases of post request
   * @param {any} callback - the callback method that is optional in case, needs to be executed after the call
   * @param {any} configOverWrite - any overwite of the default configs
   *
   * @returns {Promise} - a promise object for resolving from the caller function
   */
  runQuery: any = (
    relativeURL: string,
    method: string = "GET",
    payload: any = {},
    callback: any = () => {},
    configOverWrite: any = {}
  ) => {
    const config = {...this.getConfig(), ...configOverWrite};
    // Initializing the promise
    let axiosPromise;
    if (method === "GET") {
      axiosPromise = axios.get(this._apiEndpoint + relativeURL, config);
    } else if (method === "POST") {
      axiosPromise = axios.post(
        this._apiEndpoint + relativeURL,
        payload,
        config
      );
    } else if (method === "PUT") {
      axiosPromise = axios.put(
        this._apiEndpoint + relativeURL,
        payload,
        config
      );
    } else if (method === "DELETE") {
      axiosPromise = axios.delete(this._apiEndpoint + relativeURL, config);
    } else {
      axiosPromise = new Promise((resolve, reject) => {
        reject("Unknown method used to make API call");
      });
    }

    return axiosPromise
      .then((data: any) => {
        if (callback) {
          callback();
        }
        return data;
      })
      .catch((err: Error) => {
        let errorMessage = "Error in Request";
        if (err.message === "Network Error") {
          const networErrorDisplayMessage = `
                Not connected to the server.
                Please check your internet connection.
                Or, contact the system administrator`;
          // No Connection to the server
          errorMessage = err.message;
          // alert(networErrorDisplayMessage);
        } else if (err.message.indexOf("401") > -1) {
          localStorage.removeItem("JWT_Token");
          // window.location.reload();
        }
        throw new Error(errorMessage);
      });
  };
}

export default QueryService;
